import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  page: {
    padding: 20,
  }
}));

export default useStyles;